<template>
  <el-select :value="innerValue" filterable clearable
    :placeholder="placeholder" :disabled="disabled || !departmentId" style="width: 100%;"
    :loading="loading" @visible-change="onVisibleChange" @input="onInput">
    <el-option v-for="t in options" :key="t.Id" :label="t.TeacherName" :value="t.Id"></el-option>
  </el-select>
</template>

<script>
import { fetchTeachersByDepartment } from '../utils/meetingRoomTeacherCache';
import { normalizeOptionalIdString } from '../utils/meetingRoomForm';
import { normalizeDeptId } from '../utils/deptCascaderProps';

export default {
  name: 'MeetingRoomTeacherSelect',
  props: {
    value: {
      type: [Number, String],
      default: null
    },
    departmentId: {
      type: [Number, String],
      default: 0
    },
    placeholder: {
      type: String,
      default: '请选择教职工'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      options: [],
      loading: false,
      loadedForDept: ''
    };
  },
  computed: {
    innerValue() {
      return normalizeOptionalIdString(this.value);
    }
  },
  watch: {
    departmentId: {
      immediate: true,
      handler(val, oldVal) {
        if (oldVal != null && String(val || '') !== String(oldVal || '')) {
          this.$emit('input', null);
          this.options = [];
          this.loadedForDept = '';
        }
        if (normalizeDeptId(val)) {
          this.loadTeachers();
        }
      }
    },
    value: {
      immediate: true,
      handler(val) {
        if (val) this.ensureValueInOptions(val);
      }
    }
  },
  methods: {
    normalizeOption(row) {
      const id = normalizeOptionalIdString(row && (row.Id != null ? row.Id : row.id));
      if (!id) return null;
      return {
        Id: id,
        TeacherName: (row && (row.TeacherName || row.teacherName)) || `教职工(${id})`,
        DepartmentName: (row && (row.DepartmentName || row.departmentName)) || ''
      };
    },
    onInput(val) {
      this.$emit('input', normalizeOptionalIdString(val));
    },
    onVisibleChange(visible) {
      if (visible) this.loadTeachers();
    },
    ensureValueInOptions(id) {
      const sid = normalizeOptionalIdString(id);
      if (!sid) return;
      if (this.options.some(o => o.Id === sid)) return;
      this.options.push({ Id: sid, TeacherName: `教职工(${sid})` });
    },
    loadTeachers() {
      if (!normalizeDeptId(this.departmentId) || this.loading) return;
      const deptKey = String(this.departmentId);
      if (this.loadedForDept === deptKey && this.options.length) return;
      this.loading = true;
      fetchTeachersByDepartment(this.departmentId).then(rows => {
        this.loading = false;
        this.loadedForDept = deptKey;
        this.options = (rows || [])
          .map(row => this.normalizeOption(row))
          .filter(Boolean);
        if (this.value) this.ensureValueInOptions(this.value);
      }).catch(() => { this.loading = false; });
    }
  }
};
</script>
